import {
  Pagination,
  getDefaultPagination,
  paginationFromDto,
} from '../common/models/pagination'
import { GetOrgsOrgNotificationsParams } from '../shared/api/generated/models/getOrgsOrgNotificationsParams'
import { SiteID } from '../sites/models/site'
import {
  Notification,
  NotificationID,
  NotificationReadFilter,
  parseNotification,
} from './models/notification'

import { getCliniShiftManager } from '../shared/api/generated/endpoints/cliniShiftManager'

export interface NotificationSearchForm {
  perPage?: number
  page?: number
  /** Defaults to unread on the API when omitted. */
  filter?: NotificationReadFilter
  /** Exact types or prefixes ending in `.*`, e.g. `shift.offer.*`. */
  types?: string[]
}

const searchFormToParams = (
  form: NotificationSearchForm,
): GetOrgsOrgNotificationsParams => {
  const params: GetOrgsOrgNotificationsParams = {}

  if (form.perPage) {
    params.per_page = form.perPage
  }

  if (form.page) {
    params.page = form.page
  }

  if (form.filter) {
    params.filter = form.filter
  }

  if (form.types && form.types.length > 0) {
    params.type = form.types
  }

  return params
}

export const fetch = async (
  siteId: SiteID,
  form: NotificationSearchForm,
): Promise<{ notifications: Notification[]; pagination: Pagination }> => {
  const response = await getCliniShiftManager().getOrgsOrgNotifications(
    siteId,
    searchFormToParams(form),
  )

  return {
    notifications: response.data
      .map(parseNotification)
      .filter((notification) => notification !== null),
    pagination: response.meta.pagination
      ? paginationFromDto(response.meta.pagination)
      : getDefaultPagination(),
  }
}

export const readAll = async (siteId: SiteID): Promise<void> => {
  await getCliniShiftManager().putOrgsOrgNotifications(siteId)
}

export const read = async (
  siteId: SiteID,
  notificationId: NotificationID,
): Promise<void> => {
  await getCliniShiftManager().putOrgsOrgNotificationsNotification(
    siteId,
    notificationId,
  )
}
